const nonAlphaNumericCharMap = {
  ' ': { csMapping: ':cs-s-sp:' },
  '?': { csMapping: ':cs-s-qm:' },
  '!': { csMapping: ':cs-s-em:' },
  '&': { csMapping: ':cs-s-amp:' },
  '@': { csMapping: ':cs-s-at:' },
  ',': { csMapping: ':cs-s-com:' },
  $: { csMapping: ':cs-s-dol:' },
  '.': { csMapping: ':cs-s-fs:' },
  '#': { csMapping: ':cs-s-hash:' },
  '%': { csMapping: ':cs-s-pc:' },
};

export default nonAlphaNumericCharMap;
